import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { OemService } from '../../../core/routing/services/oem/oem.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { OemConstants } from '../../../core/routing/services/oem/constants/oem.constants';
import { PartnerContentStore } from '../../partner-content/store/partner-content-store';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { countryConstants } from 'src/app/core/routing/constants/country.constant';
import { AttractorLoopVideo } from '../interface/oem-portal-interface.i';


@Component({
  selector: 'iposcen-view-attract-admin',
  templateUrl: './view-attract-admin.component.html',
  styleUrls: ['./view-attract-admin.component.scss']
})
export class ViewAttractAdminComponent implements OnInit {
  @Output() readonly attractorViewOn = new EventEmitter();
  @Output() readonly emitEditData = new EventEmitter();
  @Output() readonly isPartnerTabActive = new EventEmitter();
  @Output() readonly checkStatusView = new EventEmitter();
  @Output() readonly checkStatusReView = new EventEmitter();
  @Output() readonly selectButton = new EventEmitter();
  @Output() readonly videoData = new EventEmitter();
  @Output() readonly goToReview = new EventEmitter();
  @Output() readonly disableAttrLoop = new EventEmitter();
  @Output('isEditON') edit = new EventEmitter();
  @ViewChild('textAreaInput') textArea: ElementRef;
  @ViewChild('viewAllLocationsModal') viewAllLocationsModal: any;
  @Input() attractorLoopId: string;
  @Input() adminRef: boolean;
  @Input() pid: string;
  @Input() getSelectedList: string;
  @Input() commentEnabled: boolean;
  attractorData: any;
  attractorLoopName: string;
  systemID: any;
  reviewStatus: string;
  assetID: string;
  configurations: any;
  comments: string;
  inputComments = '';
  hasComments: boolean = false;
  obj = Object;
  videoUrl: any;
  videoFile: any;
  private ngUnsubscribe = new Subject();
  downloadURl: string;
  partnerName: any;
  globalSortValue: string;
  globalSortBy: string;
  isApproveReject: string;
  publishDate: string;
  expiryDate: string;
  popupTitle: any;
  popupAction: any;
  systemIdSize: any;
  whichPopup: string;
  approveLabel = OemConstants.APPROVELABEL;
  RejectLabel = OemConstants.REJECTLABEL;
  doneApproveLabel = OemConstants.APPROVED;
  doneRejectLabel = OemConstants.RETURNED;
  buttonLabel = OemConstants.BUTTONLABEL;
  commentsBox = OemConstants.COMMENTS_PLACEHOLDER;
  doneState: boolean;
  name: any;
  openModal = false;
  approved = false;
  pushUpdates = false;
  devicesCount : number;
  approveandPush: boolean;
  openPushApproveModal: boolean = false;
  locations: any = [];
  selectedLocations: any = [];
  allcountries: any = [];
  excludedLocations: any= [];
  isReturnPopup: boolean;
  attractorLoop = [];
  selectedGrouped:any =[];
  excludedGrouped:any =[];
  activeTab = 'selected';

  constructor(private router: Router, private ngbModal: NgbModal, private oemservice: OemService, private store: PartnerContentStore, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.disableAttrLoop.emit(false);
    this.globalSortBy = OemConstants.CONTENT_LAST_UPDATED;
    this.globalSortValue = OemConstants.DESCENDING_ORDER;
    this.getAttractorLoopDetails(this.attractorLoopId);
    }

  getAttractorLoopDetails(attractorLoopId) {
    this.oemservice.getAttractorLoopByLoopID(attractorLoopId, this.adminRef, this.pid)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAttractorResponse => {
        this.attractorData = getAttractorResponse.attractLoop;
        this.name = this.attractorData.updatedByName
        this.attractorLoopName = getAttractorResponse.attractLoop.attractLoopName;
        this.systemID = this.obj.values(getAttractorResponse.attractLoop.systemIDMap);
        this.systemIdSize = Object.keys(getAttractorResponse.attractLoop.systemIDMap).length;
        this.reviewStatus = getAttractorResponse.attractLoop.reviewStatus;
        this.partnerName = getAttractorResponse.attractLoop.partnerName;
        let config = getAttractorResponse?.attractLoop?.configurations ? JSON.parse(getAttractorResponse?.attractLoop?.configurations) : getAttractorResponse?.attractLoop;
        this.publishDate = config ? config.publishTime : '';
        this.expiryDate = config ? config.expireTime : '';
        const assetBaseURL = this.oemservice.getAssetBaseURL(false);
        this.downloadURl = environment.apiBaseUrl + OemConstants.SLASH +
          `${assetBaseURL}${OemConstants.SLASH_ATTRACTORLOOP}${OemConstants.SLASH_ATTRACTORLOOPS}${OemConstants.SLASH}${getAttractorResponse.attractLoop.attractLoopId}`;
        this.locations = getAttractorResponse?.attractLoop?.locations ? JSON.parse(getAttractorResponse?.attractLoop?.locations) : [];
        countryConstants.forEach(element => {
          this.allcountries.push(element.nameInEng);
        });
        this.getLocationLists();
        if (getAttractorResponse?.attractLoop?.comments) {
          this.hasComments = true;
          this.comments = getAttractorResponse?.attractLoop?.comments;
        } else {
          this.hasComments = false;
        }
      });
     this.oemservice.getAllAttractorLoop(this.globalSortBy, this.globalSortValue)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(getAllAttractorLoop => {
            this.attractorLoop = getAllAttractorLoop.attractLoops as AttractorLoopVideo[];
          });
  }

  getLocationLists() {
    if (this.locations && this.locations?.length > 0) {
      this.selectedLocations = this.locations;
    } else {
      this.selectedLocations = this.allcountries;
    }
    this.excludedLocations = this.allcountries.filter(element => !this.selectedLocations.includes(element));
  }
  goEdit() {
      try {
        const editConfig = JSON.parse(this.attractorData.configurations);
        const currentAttractId = this.attractorData.attractLoopId;
        if (editConfig.groupAttractLoopId) {
          // Filter all attract loops with the same groupId
          const groupedAttracts = this.attractorLoop.filter(attract => {
            try {
              const config = attract?.configurations? JSON.parse(attract?.configurations):'';
              return config.groupAttractLoopId ===( editConfig.groupAttractLoopId  || '');
            } catch (error) {
              return false;
            }
          })
          // Sort by sequence, handling missing sequences
          const sortedAttracts = groupedAttracts.sort((a, b) => {
            try {
              const configA = JSON.parse(a.configurations);
              const configB = JSON.parse(b.configurations);

              // Handle cases where sequence might be undefined or null
              const sequenceA = typeof configA.sequence === 'number' ? configA.sequence : Infinity;
              const sequenceB = typeof configB.sequence === 'number' ? configB.sequence : Infinity;

              return sequenceA - sequenceB;
            } catch (error) {
              return 0;
            }
          })
          const selectedIndex = sortedAttracts.findIndex(attract =>
            attract.attractLoopId === currentAttractId
          );
          const attractsWithIndex = sortedAttracts.map(attract => ({
            ...attract,
            selectedIndexNum: selectedIndex
          }));
          this.edit.emit(attractsWithIndex);
        } else {
          this.edit.emit(this.attractorData);
        }
      } catch (error) {
        this.edit.emit(this.attractorData);
      }
}

  goBack() {
    if (this.adminRef) {
      this.goToApprove(this.pid)
    }
    this.attractorViewOn.emit(false);
    this.goToReview.emit(true);
  }
  checkForInput(data: string) {
    this.inputComments = data.trimStart();
    this.textArea.nativeElement.value = this.inputComments;
  }
  goToApprove(pid) {
    this.oemservice.getApprovedAttractLoopVideoBypID(this.globalSortBy, this.globalSortValue, pid)
      .subscribe(getAllContentResponse => {
        this.store.setAttrLoop(getAllContentResponse.attractLoops);
      })
    this.isPartnerTabActive.emit(false);
    this.checkStatusView.emit(true);
    this.checkStatusReView.emit(false);
    this.selectButton.emit(this.partnerName);
  }
  openPopup(modal, which: string) {    
    if (which === 'approved') {
      this.approveandPush = false;
      const payload = {
        "oemAttractloops": [{
          oemAttractloopId: this.attractorLoopId as string,
          oemAttractloopName: this.attractorLoopName as string,
          showOnDevice: true
        }]
      };
      this.oemservice.sendApproveAndPush(payload, false)
        .pipe()
        .subscribe(response => {
          this.devicesCount = response.deviceCount;
          if (this.devicesCount === 0) {  
            this.openPushApproveModal = false;
            this.isReturnPopup = false;
            this.ngbModal.open(modal);
          } else if (this.devicesCount > 0) {
            this.openPushApproveModal = true;
            this.isReturnPopup = false;
            this.ngbModal.open(modal);
          }
        },
        error => { // do something
        }); 
    } 
        this.isApproveReject = which;
        if (which === 'returned') {
          this.isReturnPopup = true;
          this.openPushApproveModal = false;
          this.ngbModal.open(modal);
        }
        this.popupTitle = which === 'approved' ? this.approveLabel : this.RejectLabel;
        this.popupAction = which === 'approved' ? this.approveLabel : this.buttonLabel;
        this.whichPopup = which;
  }
  closePopup(modal) {
    modal.close()
    if (this.doneState) {
      this.goBack();
    }
  }
  //IIT3-32
  sendMail() {
    const payload = {
      comments: this.inputComments as string
    };
    this.oemservice.sendApproveReject(this.isApproveReject, this.pid, this.attractorLoopId, payload)
      .subscribe(res => {
        this.doneState = true;
      });
  }

  approveAndPushModal(modal) {
    modal.close();
    if (this.doneState) {
      this.goBack();
    }
    this.openModal = !this.openModal;
    this.pushUpdates = !this.pushUpdates;
    this.approved = false;
    this.approveandPush = true
    this.approveModal(modal);
    setTimeout(() => {
      this.pushUpdatesModal();
    }, 2000);
  }
  approveModal(modal) {
    if (!this.approveandPush) {
      modal.close();
      if (this.doneState) {
        this.goBack();
      }
      this.openModal = !this.openModal;
      this.approved = !this.approved;
      this.pushUpdates = false;
    }
    const payload = {
      comments: this.inputComments as string
    };
    this.oemservice.sendApproveReject(this.isApproveReject, this.pid, this.attractorLoopId, payload)
      .subscribe(res => {
        this.doneState = true;
      });
  }
  //IIT3-32 Modal for push the updates
  pushUpdatesModal() {
    this.approveandPush = false;
    const payload = {
      "oemAttractloops": [{
        oemAttractloopId: this.attractorLoopId as string,
        oemAttractloopName: this.attractorLoopName as string,
        showOnDevice: true
      }]
    };
    this.oemservice.sendApproveAndPush(payload, true)
      .pipe()
      .subscribe(response => {
        this.devicesCount = response.deviceCount;
        this.doneState = true;
      },
      error => { // do something
      });
  }

  closeModal() {
    this.openModal = false;
    this.pushUpdates = false;
    this.approved = false;
    if (this.doneState) {
      this.goBack();
    }
  }
  openModalViewLocation(locationType?: string) {
    this.selectedGrouped = this.groupByAlphabet(this.selectedLocations);
    this.excludedGrouped = this.groupByAlphabet(this.excludedLocations);
    this.activeTab = locationType === 'excluded' ? 'excluded' : 'selected';
    this.ngbModal.open(this.viewAllLocationsModal);
  }

groupByAlphabet(arr:string[])
{
  const grouped:any ={};
  arr.sort().forEach(country =>{
    const letter =country.charAt(0).toUpperCase();
    if(!grouped[letter]){
      grouped[letter] = [];
    }
    grouped[letter].push(country);
  });  
  return grouped;
}
}
